import { Component, Vue } from 'vue-property-decorator';
import { DerBodyBlockViewModel } from './DerBodyModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import Share from '@/components/Share/Share.vue';
import ArticleAuthor from '@/components/ArticleAuthor/ArticleAuthor.vue';
import ArticleHeader from '@/components/ArticleHeader/ArticleHeader.vue';
import ArticleText from '@/components/ArticleText/ArticleText.vue';
import { getResizeImage } from '@/utils/commonUtils';

import { format } from 'date-fns';
// icons
import Read from '@/assets/icons/read.svg?inline';
import IconCalendar from '@/assets/icons/calendar.svg?inline';
import Ship from '@/assets/icons/ship.svg?inline';
import Pin from '@/assets/icons/pin.svg?inline';
import Compass from '@/assets/icons/compass.svg?inline';

const DerBodyModuleProps = Vue.extend({
  props: getComponentProps<DerBodyBlockViewModel>({
    Title: 'George Island and Inians',
    Date: new Date(2019, 6, 16),
    Ship: 'National Geographic Orion',
    Location: 'George Island and Inians',
    Coordinates: { Latitude: '64.4327', Longitude: '-173.2386' },
    Text: `<p>Our westward progress across the Bering Sea continued this morning. So fair was the wether that we have finally reached the fabled Beringia Land Bridge. Once the geographic link between North America and Russia, now a great ocean separates these two world powers.</p><br/><p>This morning we took advantage of easing political tensions and stepped foot upon Russian soil. After docking in the north eastern port of Provideniya, we were greeted with open arms by the locals – and with a traditional song from the town’s Little Sun Dancers.</p><br/><p>Guests first took to the hills for a morning time hike, later taking in the museum and some curious street theatre. With splendid temperatures and atmospheric fog rolling through the harbour, our time in Russia, though brief, proved itself nothing short of charming.</p><br/><p>At dusk we gathered on deck and waved farewell. Onwards we journey. Next stop, Alaska.</p>`,
    ArticleAuthors: [
      {
        Image: { Url: getResizeImage('thumbnail-sven.jpg'), Alt: 'Sven' },
        Name: 'Peter Hillary',
        Text:
          'The son of Sir Edmund Hillary, Peter is the first second-generation to climb Mt. Everest. He has climbed the Seven Summits, been on over 40 mountaineering expeditions around the world, and in 1999, he established one of the five Ross Sea routes to the South Pole via the Shackleton Glacier.',
        Link: '#',
        Title: 'Mountaineer',
        ArticleRole: 'Article by',
      },
      {
        Image: { Url: getResizeImage('thumbnail-sven.jpg'), Alt: 'Sven' },
        Name: 'June Glebb',
        Text:
          'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Necessitatibus ex eos officiis mollitia fugiat qui nulla aliquid. Id vel consequatur quae ex quod minus placeat aliquid, laudantium tempore aspernatur qui!',
        Link: '#',
        Title: 'Mountaineer',
        ArticleRole: 'Videography by',
      },
      {
        Image: { Url: getResizeImage('captain-kruess.jpg'), Alt: 'Kreuss' },
        Name: 'James McCloyd',
        Text:
          'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Necessitatibus ex eos officiis mollitia fugiat qui nulla aliquid. Id vel consequatur quae ex quod minus placeat aliquid, laudantium tempore aspernatur qui!',
        Link: '#',
        ArticleRole: 'Expedition led by',
        Title: 'Mountaineer',
      },
    ],
    ShareData: {
      Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
      Title: 'Share Report',
      Description: 'Daily Expedition Report',
      Hashtags: 'report,travel,lindblad',
      Quote: 'Lindblad report - facebook',
      TwitterUser: 'LindbladExp',
    },
    ShowHeader: null,
  }),
});

@Component({
  components: {
    Share,
    ArticleAuthor,
    ArticleHeader,
    ArticleText,
    Read,
    IconCalendar,
    Ship,
    Pin,
    Compass,
  },
})
export default class DerBodyModule extends DerBodyModuleProps {
  get ArticleData() {
    return this.p;
  }

  get HasHeader() {
    return this.p.ShowHeader;
  }

  get reformattedDate() {
    const date = new Date(this.p.Date);
    return format(date, 'dd MMM Y');
  }

  get coordinates() {
    if (!this.p.Coordinates) {
      return '';
    }
    let { Latitude, Longitude } = this.p.Coordinates;
    if (!Latitude || !Longitude) return null;
    if (parseFloat(Latitude) < 0) {
      Latitude = Math.abs(parseFloat(Latitude)).toString() + '° S';
    } else if (parseFloat(Latitude) > 0) {
      Latitude = Math.abs(parseFloat(Latitude)).toString() + '° N';
    }
    if (parseFloat(Longitude) < 0) {
      Longitude = Math.abs(parseFloat(Longitude)).toString() + '° W';
    } else if (parseFloat(Longitude) > 0) {
      Longitude = Math.abs(parseFloat(Longitude)).toString() + '° E';
    }
    return Latitude + ', ' + Longitude;
  }
}
